export { default as AccountService } from "services/account-service";
export { default as CourceService } from "services/courses-service";
export { default as AuthService } from "services/auth-service";
export { default as PayoutService } from "services/payout-service";
export { default as UserService } from "services/user-service";
export { default as VerificationService } from "services/verification-service";
export { default as GoogleTagManager } from "services/GoogleTagManager";
export { default as $api } from "services/api"
export { storage } from "services/storage";